import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Editingtool from "../Pages/Editingtool";

function AddAccessPlanPage() {
  const [formData, setFormData] = useState({
    planTitle: "",
    planSKU: "",
    enrollText: "",
    visibility: "visibility",
    isFree: false,
    price: "",
    frequency: "",
    accessExpiration: "",
    planAvailability: "",
    salePricing: "",
    // Add other fields as needed
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  const handleAddAccessPlan = (e) => {
    e.preventDefault();
    // Add logic to handle access plan addition, e.g., make an API call
    console.log("Access Plan added:", formData);
    // Reset form data
    setFormData({
      planTitle: "",
      planSKU: "",
      enrollText: "",
      visibility: "public",
      isFree: false,
      price: "",
      frequency: "",
      accessExpiration: "",
      planAvailability: "",
      salePricing: "",
      // Reset other fields as needed
    });
  };

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0" style={{  margin: "auto" }}>
        <Accordion.Header> Access Plan </Accordion.Header>

        <Accordion.Body>
          <Card.Body>
            <h4>New Access Plan</h4>
            <form>
              <div className="  mb-3 mt-3">
                <label htmlFor="courseTitle" className="form-label">
                  Course Title:
                </label>
                <div className="mb-3 input-group">
                  <label
                    htmlFor="planTitle"
                    className="form-label visually-hidden"
                  >
                    Plan Title :
                  </label>
                  <input
                    type="text"
                    id="planTitle"
                    name="planTitle"
                    className="form-control"
                    value={formData.planTitle}
                    onChange={handleInputChange}
                    placeholder="Plan Title"
                  />
                </div>
              </div>
              

              <h6>Plan SKU :</h6>
              <div className="mb-3 input-group">
                <label htmlFor="planSKU" className="form-label visually-hidden">
                  Plan SKU :
                </label>
                <input
                  type="text"
                  id="planSKU"
                  name="planSKU"
                  className="form-control"
                  value={formData.planSKU}
                  onChange={handleInputChange}
                  placeholder="Plan SKU"
                />
              </div>
              <h6> Enroll Text :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="enrollText"
                  className="form-label visually-hidden"
                >
                  Enroll Text:
                </label>
                <input
                  type="text"
                  id="enrollText"
                  name="enrollText"
                  className="form-control"
                  value={formData.enrollText}
                  onChange={handleInputChange}
                  placeholder="Enroll Text"
                />
              </div>
              <h6> Visibility :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="visibility"
                  className="form-label visually-hidden"
                >
                  Visibility:
                </label>
                <select
                  id="visibility"
                  name="visibility"
                  className="form-select"
                  value={formData.visibility}
                  onChange={handleInputChange}
                >
                  <option value="public">Public</option>

                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </select>
              </div>

              <div className="mb-3 input-group">
                <div className="form-check">
                  <input
                    type="checkbox"
                    id="isFree"
                    name="isFree"
                    className="form-check-input"
                    checked={formData.isFree}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="isFree" className="form-check-label">
                    Is Free (No payment required)
                  </label>
                </div>
              </div>
              <h6> Price :</h6>
              <div className="mb-3 input-group">
                <label htmlFor="price" className="form-label visually-hidden">
                  Price:
                </label>
                <input
                  type="text"
                  id="price"
                  name="price"
                  className="form-control"
                  value={formData.price}
                  onChange={handleInputChange}
                  placeholder="Price"
                />
              </div>
              <h6> Frequency :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="frequency"
                  className="form-label visually-hidden"
                >
                  Frequency:
                </label>
                <input
                  type="text"
                  id="frequency"
                  name="frequency"
                  className="form-control"
                  value={formData.frequency}
                  onChange={handleInputChange}
                  placeholder="Frequency"
                />
              </div>
              <h6>Access Expiration :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="accessExpiration"
                  className="form-label visually-hidden"
                >
                  Access Expiration:
                </label>
                <select
                  id="accessExpiration"
                  name="accessExpiration"
                  className="form-select"
                  value={formData.accessExpiration}
                  onChange={handleInputChange}
                >
                  <option value="Visibility" disabled>
                    Select Visibility
                  </option>

                  <option value="Lifetimeaccess">Lifetime access</option>
                  <option value="access">access</option>
                  <option value="access">access</option>
                </select>
              </div>
              <h6>Plan Availability :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="planAvailability"
                  className="form-label visually-hidden"
                >
                  Plan Availability:
                </label>
                <input
                  type="text"
                  id="planAvailability"
                  name="planAvailability"
                  className="form-control"
                  value={formData.planAvailability}
                  onChange={handleInputChange}
                  placeholder="Plan Availability"
                />
              </div>
              <h6>Sale Pricing :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="salePricing"
                  className="form-label visually-hidden"
                >
                  Sale Pricing:
                </label>
                <input
                  type="text"
                  id="salePricing"
                  name="salePricing"
                  className="form-control"
                  value={formData.salePricing}
                  onChange={handleInputChange}
                  placeholder="Sale Pricing"
                />
              </div>
              <Editingtool />
              <h6 className="mt-3">Checkout redirect :</h6>
              <div className="mb-3 input-group">
                <label
                  htmlFor="accessExpiration"
                  className="form-label visually-hidden"
                >
                  Checkout redirect
                </label>
                <select
                  id="accessExpiration"
                  name="accessExpiration"
                  className="form-select"
                  value={formData.accessExpiration}
                  onChange={handleInputChange}
                >
                  <option value="Visibility" disabled>
                    Select Visibility
                  </option>

                  <option value="Lifetimeaccess">Return to course</option>
                  <option value="access">Redirect to wordpress page</option>
                  <option value="access">Redirect to custom url</option>
                </select>
              </div>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={handleAddAccessPlan}
                >
                  Add Access Plan
                </button>
              </div>
            </form>
          </Card.Body>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default AddAccessPlanPage;
